export const FEEDBACK_FORM_SUBMIT_START = 'FEEDBACK_FORM_SUBMIT_START';
export const FEEDBACK_FORM_SUBMIT_SUCCESS = 'FEEDBACK_FORM_SUBMIT_SUCCESS';
export const FEEDBACK_FORM_SUBMIT_ERROR = 'FEEDBACK_FORM_SUBMIT_ERROR';
